import api from '../utils/api';

/**
 * @param {{ page?: number, limit?: number, search?: string, gateway?: string, sortBy?: 'totalStock' | 'createdAt' }} params
 */
export const getProducts = async (params = {}) => {
  const response = await api.get('/products', { params });
  return response.data;
};

export const getProduct = async (id) => {
  const response = await api.get(`/products/${id}`);
  return response.data;
};

export const createProduct = async (productData) => {
  const response = await api.post('/products', productData);
  return response.data;
};

export const updateProduct = async (id, productData) => {
  const response = await api.put(`/products/${id}`, productData);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await api.delete(`/products/${id}`);
  return response.data;
};

/**
 * به‌روزرسانی موجودی: ابتدا از طریق API دیجی‌کالا/باسلام؛ در صورت موفقیت در دیتابیس ذخیره می‌شود.
 * @param {string} id - شناسه محصول
 * @param {{ stock: number, applyTo: 'product' | 'variant', logicalVariantId?: string }} data
 */
export const updateProductStock = async (id, data) => {
  const response = await api.patch(`/products/${id}/stock`, data);
  return response.data;
};

/**
 * همگام‌سازی موجودی فعلی محصول با همه درگاه‌ها
 * @param {string} id - شناسه محصول
 * @param {{ applyTo: 'product' | 'variant', logicalVariantId?: string }} data
 */
export const syncProductStock = async (id, data = {}) => {
  const response = await api.post(`/products/${id}/sync-stock`, data);
  return response.data;
};
